import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertyCapexFile } from '../../../../queries/PropertyFileFields/RentalFiles';

interface CapitalExpendituresFileParameter {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const CapitalExpendituresFile: React.FC<CapitalExpendituresFileParameter> = ({
    propertyGuid,
    required,
    isReview = false,
}) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId } = usePropertyCapexFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label='Capital Expenditures'
                    selector='capitalExpenditures'
                    fileType='capital expenditures'
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
